export enum MenuStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published'
}

export type MenuItemOptions = {
  title: string;
  icon: {
    prefix: string;
    iconName: string;
  } | null;
  visible: boolean;
  noFollow: boolean;
  noReferrer: boolean;
  noOpener: boolean;
  openNewTab: boolean;
  classes: string | null;
  availableFrom?: number | null;
};

export enum MenuItemType {
  INTERNAL = 'internal',
  EXTERNAL = 'external'
}

export type MenuItem = {
  id: string;
  name: string;
  type: MenuItemType;
  resource: string;
  options: MenuItemOptions;
  items: MenuItem[] | null;
};

export type Menu = {
  id: string;
  name: string;
  slot: string;
  status: MenuStatus;
  items: MenuItem[];
};
